import Popover from '@components/popover';
import cn from 'clsx';
import { observer } from 'mobx-react-lite';
import React, { useEffect } from 'react';

import { useStore } from 'hooks/useStore';
import { interpolate } from 'utils/string/format';

import css from './GeoInformer.module.css';

interface GeoInformerProps {
  children: React.ReactElement;
  className?: string;
}

const geoInformerDelay = 3000;

const GeoInformer = ({ children, className }: GeoInformerProps) => {
  const {
    app: { i18n },
    filter: { geoInfomer },
  } = useStore();

  useEffect(() => {
    // Из-за сдвига вёрстки верхним баннером, поповер остаётся на месте
    // и оказывается выше своего места. Проблема в tippy.js.
    // Задерживаем инициализацию на магическое время, чтобы дождаться загрузки баннера.
    const geoInfomerTimer = setTimeout(() => {
      geoInfomer.init();
    }, geoInformerDelay);

    return () => clearTimeout(geoInfomerTimer);
  }, [geoInfomer]);

  if (typeof window === 'undefined') return <div className={className}>{children}</div>;

  const content = (
    <>
      <Popover.Header>
        {interpolate(i18n.route.geoInformer.showCargosFrom, { place: geoInfomer.geoInfo?.fromGeoPopupText })}
      </Popover.Header>
      <Popover.Footer>
        <Popover.ActionWrapper>
          <button className="glz-button glz-is-primary glz-is-small" onClick={geoInfomer.searchLoads}>
            {i18n.route.geoInformer.show}
          </button>
        </Popover.ActionWrapper>
        <Popover.ActionWrapper>
          <button
            className={cn(css.otherPlace, 'glz-link glz-is-medium glz-is-gray glz-is-pseudo')}
            onClick={geoInfomer.cancelInformer}
          >
            {i18n.route.geoInformer.otherPlace}
          </button>
        </Popover.ActionWrapper>
      </Popover.Footer>
    </>
  );

  return (
    <Popover
      isClosedOnOutsideClick
      classNames={{ childrenWrapper: className }}
      content={content}
      visible={geoInfomer.isVisible}
      onCloseClick={geoInfomer.cancelInformer}
      onVisibilityChange={geoInfomer.setIsVisible}
    >
      {children}
    </Popover>
  );
};

const connected = observer(GeoInformer);

export { connected as GeoInformer };
